'use client';

import { useParams } from 'next/navigation';
import { PropsWithChildren } from 'react';

import { useSelectorScrollLogging } from '@flipster/features/src/shared/scroll-logging';
import segment, { marketingEventEvent } from '@flipster/utils/segment';

export const MainWithLogging = ({ children }: PropsWithChildren) => {
  const { slug } = useParams<{ slug: string }>();

  const ref = useSelectorScrollLogging(':scope > section', (index, dataset) => {
    segment.track(marketingEventEvent.scrolled, {
      scroll_direction: 'vertical',
      event_path: slug,
      section_type: dataset.sectionType ?? 'unknown',
      section_index: index,
    });
  });

  return <main ref={ref}>{children}</main>;
};
